import { render, staticRenderFns } from "./reasonCancel.vue?vue&type=template&id=5f94a822&scoped=true"
import script from "./reasonCancel.vue?vue&type=script&lang=js"
export * from "./reasonCancel.vue?vue&type=script&lang=js"
import style0 from "./reasonCancel.vue?vue&type=style&index=0&id=5f94a822&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f94a822",
  null
  
)

export default component.exports